// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1dV8K","header":"PatientBlock_header__1qSdt","label":"PatientBlock_label__12nGP","option":"PatientBlock_option__2hJ8k"};